import { LinkButton, Typography } from '@weareopenr/component-library';
import { useMemo } from 'react';
import classnames from 'classnames/bind';
import SelectableList, { SelectableListOption } from '../SelectableList/SelectableList';
import styles from './SelectableListWithControls.module.scss';

const cx = classnames.bind(styles);

export interface SelectableListWithControlsProps {
  options: SelectableListOption[];
  selectedOptions: string[];
  onChange: (selectedOptions: string[]) => void;
  className?: string;
  children?: React.ReactNode;
}

const SelectableListWithControls = ({
  options,
  selectedOptions,
  onChange,
  className,
  children,
}: SelectableListWithControlsProps) => {
  const allOptionIds = useMemo(() => options.map((option) => option.id), [options]);

  const handleSelectAll = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (allSelected) {
      const filteredOptions = selectedOptions.filter((item) => !allOptionIds.includes(item));
      onChange(filteredOptions);
    } else {
      onChange(Array.from(new Set(selectedOptions.concat(allOptionIds))));
    }
  };

  const selectedSet = new Set(selectedOptions);
  const allSelected = allOptionIds.every((id) => selectedSet.has(id));

  return (
    <div className={className}>
      <div className={styles['controls-container']}>
        {children && <div className={cx('filters-container')}>{children}</div>}
        <div className={styles['select-all-controls']}>
          <Typography className={styles['current-selected']} size="xsmall">
            {`Current selected - ${selectedOptions.length}`}
          </Typography>
          {options.length ? (
            <LinkButton aria-label="Select all checkbox" className={styles['select-button']} onClick={handleSelectAll}>
              {allSelected ? `Deselect all (${options.length})` : `Select all (${options.length})`}
            </LinkButton>
          ) : (
            <Typography weight="semi-bold">No results for your search</Typography>
          )}
        </div>
      </div>

      <div className={styles['list-scroll-container']}>
        <SelectableList options={options} selectedOptions={selectedOptions} onChange={onChange} />
      </div>
    </div>
  );
};

export default SelectableListWithControls;
